import QuestionMarkCircleIcon from '@icons/question-mark-circle'
import ChatBubbleLeftRightIcon from '@icons/chat-bubble-left-right'
import { useFeedback } from '@/lib/provider/FeedbackProvider'
import { Help } from '../Help'

const StatusSupportPanel = () => {
  const { isFeedbackEnabled, openFeedback } = useFeedback()

  return (
    <aside className="relative flex w-full shrink-0 flex-col overflow-hidden bg-brand-1 md:w-80">
      <div className="pointer-events-none absolute -left-10 -top-10 h-44 w-44 rounded-full bg-surface/[0.05] blur-3xl" />
      <div className="pointer-events-none absolute -bottom-8 -right-8 h-36 w-36 rounded-full bg-auxiliary-2/20 blur-2xl" />

      <div className="relative z-10 border-b border-white/[0.08] px-4 pb-3 pt-4">
        <div className="flex items-center gap-2">
          <div className="flex h-6 w-6 items-center justify-center rounded-md bg-surface/10 ring-1 ring-white/[0.12]">
            <QuestionMarkCircleIcon className="h-3.5 w-3.5 text-white/70" />
          </div>
          <p className="font-semibold text-white">Support</p>
        </div>
        <p className="mt-1.5 text-sm leading-relaxed text-white/45">
          Found a bug or have a suggestion for how we can improve the portal?
          Let us know and we&apos;ll get to work on it.
        </p>

        {isFeedbackEnabled && (
          <button
            type="button"
            onClick={() => openFeedback()}
            className="mt-3 inline-flex items-center gap-2 rounded-lg bg-surface/10 px-3 py-1.5 text-sm font-medium text-white ring-1 ring-inset ring-white/15 transition hover:bg-surface/20"
          >
            <ChatBubbleLeftRightIcon className="size-4 text-white/70" />
            Send feedback
          </button>
        )}
      </div>

      <div className="relative z-10 px-4 pb-5 pt-3">
        <Help embedded panel theme="dark" />
        <div className="text-sm leading-relaxed text-white/45 mt-2 mx-2">
          Please note: Support requests may be subject to charges. Emergency
          support is only provided for live services.
        </div>
      </div>
    </aside>
  )
}

export default StatusSupportPanel
